import React, { Fragment } from "react";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import CurriculumUpload from "../../components/Curriculum/CurriculumUpload";
import "../../components/StudentGoal/StudentGoal.scss";

export default function MyCurriculumUpload() {
  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner student-goal-page">
            <CurriculumUpload />
          </div>
        </div>
      </div>
    </Fragment>
  );
}
